import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, MapLocKeys } from '@cm/core/localization';

const sharedProps: Pick<LocDef, 'htmlAllowed' | 'shared' | 'feature' | 'portal'> = {
	htmlAllowed: false,
	shared: false,
	feature: HubFeature.OtherRequirementUploadCandidateAccessAudits,
	portal: 'CP',
};

type CPAuditHistoryItemsLoc =
	| 'CPAuditHistoryItemsTitle'
	| 'CPAuditHistoryItemsDescription'
	| 'CPAuditHistoryItemsStarted'
	| 'CPAuditHistoryItemsStatus'
	| 'CPAuditHistoryItemsDue'
	| 'CPAuditHistoryItemsCompleted'
	| 'CPAuditHistoryItemsName'
	| 'CPAuditHistoryItemsCreated';

export const cpAuditHistoryItemsLocs: LocDefs<CPAuditHistoryItemsLoc> = {
	CPAuditHistoryItemsTitle: {
		defaultValue: 'Audit Overview',
		description: 'Section title for the audit history items section.',
		displayPath: `History|Audit|Details|Items|Section Title`,
		displayType: 'Title',
		...sharedProps,
	},
	CPAuditHistoryItemsDescription: {
		defaultValue: '',
		description: 'Section description for the audit history items section.',
		displayPath: `History|Audit|Details|Items|Section Description`,
		displayType: 'Content',
		...sharedProps,
	},
	CPAuditHistoryItemsStarted: {
		defaultValue: 'Started',
		description: 'Started date for the audit history items section.',
		displayPath: `History|Audit|Details|Items|Started`,
		displayType: 'Label',
		...sharedProps,
	},
	CPAuditHistoryItemsStatus: {
		defaultValue: 'Status',
		description: 'Status for the audit history items section.',
		displayPath: `History|Audit|Details|Items|Status`,
		displayType: 'Label',
		...sharedProps,
	},
	CPAuditHistoryItemsDue: {
		defaultValue: 'Due',
		description: 'Due date for the audit history items section.',
		displayPath: `History|Audit|Details|Items|Due`,
		displayType: 'Label',
		...sharedProps,
	},
	CPAuditHistoryItemsCompleted: {
		defaultValue: 'Closed',
		description: 'Completed date for the audit history items section.',
		displayPath: `History|Audit|Details|Items|Completed`,
		displayType: 'Label',
		...sharedProps,
	},
	CPAuditHistoryItemsName: {
		defaultValue: 'Name',
		description: 'Name for the audit history items section.',
		displayPath: `History|Audit|Details|Items|Name`,
		displayType: 'Label',
		...sharedProps,
	},
	CPAuditHistoryItemsCreated: {
		defaultValue: 'Created',
		description: 'Created date for the audit history items section.',
		displayPath: `History|Audit|Details|Items|Created`,
		displayType: 'Label',
		...sharedProps,
	},
};

export const cpAuditHistoryItemsLocKeys =
	MapLocKeys<CPAuditHistoryItemsLoc>(cpAuditHistoryItemsLocs);
export type CPAuditHistoryItemsLocKeys = typeof cpAuditHistoryItemsLocKeys;
